import { Link } from 'react-router-dom';

const LocationsHero = () => {
  return (
    <section className="relative h-screen min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/ab344b5f509403876d79e410b25a4661.jpg"
        alt="Custom Clothiers Massachusetts service areas — Wellesley and surrounding communities"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/85 to-black/40"></div>
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl">
          <div className="inline-flex items-center bg-white/10 backdrop-blur-sm border border-[#C4A962]/50 rounded-full px-6 py-2.5 mb-8">
            <i className="ri-map-pin-line text-[#C4A962] mr-2 text-sm"></i>
            <span className="text-white text-sm font-medium tracking-widest uppercase">Wellesley, MA &amp; All of Massachusetts</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-none tracking-tight">
            Custom Tailoring<br />
            <span className="text-[#C4A962]">Near You</span>
          </h1>
          <p
            className="text-xl text-white mb-10 leading-relaxed bg-black/40 backdrop-blur-sm rounded-xl px-5 py-4 border-l-4 border-[#C4A962]"
            style={{ textShadow: '0 1px 8px rgba(0,0,0,1)' }}
          >
            Based in Wellesley — serving all of Massachusetts and New England with
            in-store appointments and house &amp; office call visits right at your location.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="bg-[#C4A962] text-white px-9 py-4 rounded-lg text-lg font-semibold hover:bg-[#B39952] transition-all transform hover:scale-105 whitespace-nowrap text-center"
            >
              <i className="ri-calendar-line mr-2"></i>Book an Appointment
            </Link>
            <a
              href="tel:781-237-3166"
              className="bg-white/10 backdrop-blur-sm border border-white/30 text-white px-9 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap text-center"
            >
              <i className="ri-phone-line mr-2"></i>781-237-3166
            </a>
          </div>

          <div className="mt-14 grid grid-cols-3 gap-5 max-w-md">
            {[
              { icon: 'ri-car-line', label: 'House &', sub: 'Office Calls' },
              { icon: 'ri-store-2-line', label: 'Wellesley', sub: 'Showroom' },
              { icon: 'ri-global-line', label: 'All of', sub: 'Massachusetts' },
            ].map((item) => (
              <div key={item.label} className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl px-3 py-5 text-center">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                  <i className={`${item.icon} text-[#C4A962] text-2xl`}></i>
                </div>
                <p className="text-white font-semibold text-xs leading-tight">{item.label}<br />{item.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce hidden md:block">
        <div className="w-8 h-8 flex items-center justify-center border border-white/30 rounded-full">
          <i className="ri-arrow-down-line text-white text-sm"></i>
        </div>
      </div>
    </section>
  );
};

export default LocationsHero;
